import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getDCompaniesAsUnits =  (): Promise<IGetDCompaniesAsUnits[]> => {
  return axiosDefaultApi.get(`/api/DCompanies/GetDCompaniesAsUnits`);
};

type QueryFnType = typeof getDCompaniesAsUnits;

type UseGetDCompaniesAsUnitsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetDCompaniesAsUnits = ({ config }: UseGetDCompaniesAsUnitsOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getDCompaniesAsUnits'],
    queryFn: () => getDCompaniesAsUnits(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};